import i18n from "i18next";

export const i18nText = {
    exists: (...rest) => {
        let result = false;        

        for(let index in rest) 
        {
            const value = rest[index];

            if (value == null || typeof value !== "object")
                continue;

            let text = value[i18n.language.substring(0, 2)];
            if (text == null || typeof text === "undefined" || text.length === 0) {                
                const keys = Object.keys(value);
                if (keys.length > 0)
                    text = value[keys[0]];
            }

            if (text == null || typeof text === "undefined" || text.length === 0)
                continue;

            result = true;
            break;
        }

        return result;
    },
    getText: (value, args) => {
        if (!i18nText.exists(value))
            return "";

        let text = value[i18n.language.substring(0, 2)];
        if (text == null || typeof text === "undefined" || text.length === 0) {
            const keys = Object.keys(value);
            if (keys.length > 0)
                text = value[keys[0]];
        }

        if (args){
            for (let [key, value] of Object.entries(args)) {
                text = text.replace("{{" + key + "}}", value);
            }
        }
        return text;
    }
}

export default i18nText;

